import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import AutoBind from 'react-autobind';

import {
    Factura_Anulacion_Consultar, Factura_Anulacion, Sucursal_Lista, SAT_MotivoCancelacion_Lista, Sucursal_ListaFiltro, Sucursal_Fiscal_Liskey, SAT_MotivoCancelacion_ListaFiltro_TipoFactura
} from '../../request/rfc';

const DefaultOptionSucursal = { Suc_Id: 0, Nombre: 'Seleccione una Sucursal >>' };
const DefaultOptionRegimenFiscalCancelacion = { Clave: "Seleccione una Cancelacion >>", Descripcion: '' };

export default class Anulacion extends Component {

    constructor(props) {

        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            factura: '',
            Suc_Id: 0,
            rfc: '',
            uuid: '',
            fiscalTipo: 0,
            anulacion_EstadoCFDI: '',
            anulacion_EstadoCFDIServicio: '',
            anulacion_SubEstadoCFDIServicio: '',
            anulacion_HorasSolicitudCFDI: '',
            impuesto: 0,
            total: 0,
            regimenFiscalCancelacion: '',
            stateUuidRelacionado: true,
            articulos: [],
            sucursales: [],
            showModal: false,
            disabled: false,
            anulacionDisabled: false,
            regimenFiscalCancelaciones: [],

            Serie: '',
            FiltroBusqueda: '',
            TipoComprobante: '',
            TipoFactura: '',
            IEPS: 0,
            Descuento: 0,
            uuidRel: '',
            uuidRelacionado: '',
            disabledTipoFacturaCancelacion: false
        };
        AutoBind(this);
    }

    //Método que se ejecuta depués del constructor
    componentDidMount() {
        this.cargarSucursales();
        this.cargarRegimenFiscalCancelacion();
    }

    cargarRegimenFiscalCancelacion() {
        SAT_MotivoCancelacion_Lista()
            .then(({ data: Response }) => {
                const { Message, Data: Cancelaciones} = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ regimenFiscalCancelaciones: [DefaultOptionRegimenFiscalCancelacion, ...Cancelaciones] });
                    //this.setState({ regimenFiscalCancelaciones: Data.map(item => Object.assign({}, item, { Descripcion: `${item.Descripcion} - ${item.Clave}` })) });
                }
            })
            .catch((err) => { console.log(err); });
    }
    SAT_MotivoCancelacion_ListaFiltro_TipoFactura(pClave) {
        SAT_MotivoCancelacion_ListaFiltro_TipoFactura(pClave)
            .then(({ data: Response }) => {
                const { Message, Data: Cancelaciones } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ regimenFiscalCancelaciones: [DefaultOptionRegimenFiscalCancelacion, ...Cancelaciones] });
                    //this.setState({ regimenFiscalCancelaciones: Data.map(item => Object.assign({}, item, { Descripcion: `${item.Descripcion} - ${item.Clave}` })) });
                }
            })
            .catch((err) => { console.log(err); });
    }
    //Cargar combo Sucursales
    cargarSucursales() {
        Sucursal_Lista()
            .then(({ data: Response }) => {
                const { Message, Data: sucursales } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ sucursales: [DefaultOptionSucursal, ...sucursales] });
                }
            }).catch((err) => { console.log('Error:' + err); });
    }

    onClean() {
        this.setState({
            factura: '',
            Suc_Id: 0,
            rfc: '',
            uuid: '',
            fiscalTipo: 0,
            anulacion_EstadoCFDI: '',
            anulacion_EstadoCFDIServicio: '',
            anulacion_SubEstadoCFDIServicio: '',
            anulacion_HorasSolicitudCFDI: '',
            impuesto: 0,
            total: 0,
            articulos: [],
            showModal: false,
            disabled: false,
            anulacionDisabled: false
        });
    }

    //Cuando se modifica algún estado
    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        if (name === 'regimenFiscalCancelacion') {

            if (value === '01') {
                this.setState({ stateUuidRelacionado: false });
                this.cargarCFDICandelado();
            }
            else {
                this.setState({ stateUuidRelacionado: true, cfdiCancelado: [], uuid: '' });
            }
        }
        if (name === 'FiltroBusqueda') {
            this.Sucursal_ListaFiltro(value);
            this.setState({ Serie: '' });
        }

        if (name === 'Serie') {
            this.Sucursal_Fiscal_Liskey(value);
            this.setState({ FiltroBusqueda: '' });
        }
    }

    Sucursal_ListaFiltro(pNombre) {
        Sucursal_ListaFiltro(pNombre)
            .then(({ data: Response }) => {
                const { Message, Data: sucursales } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ sucursales: [DefaultOptionSucursal, ...sucursales] });
                }
            }).catch((err) => { console.log('Error:' + err); });
    }

    Sucursal_Fiscal_Liskey(pNombre) {
        Sucursal_Fiscal_Liskey(pNombre)
            .then(({ data: Response }) => {
                const { Message, Data: sucursales } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ sucursales: [DefaultOptionSucursal, ...sucursales] });
                }
            }).catch((err) => { console.log('Error:' + err); });
    }

    //Evento para consultar la Factura
    onConsultarFactura() {
        const { Suc_Id, factura } = this.state;
        if (Suc_Id === '' || Suc_Id === 0 || factura === '') {
            alert('Debe ingresar los valores de Sucursal y Número Factura para poder realizar la consulta.');
            return;
        } else {
            this.setState({ disabled: true });
            Factura_Anulacion_Consultar({ pSucursal: Suc_Id, pFactura: factura })
                .then(({ data: Response }) => {
                    this.setState({ disabled: false });
                    const { Message, Data } = Response;
                    if (Message !== '') {
                        alert(Message);
                    } else {
                        if (Data.length > 0) {
                            Data.map(item => {
                                this.setState({
                                    rfc: item.ClienteFiscal_Id,
                                    uuid: item.UUID,
                                    uuidRel: item.UUIDRelacionado,
                                    fiscalTipo: item.Fiscal_Tipo,
                                    anulacion_EstadoCFDI: item.Anulacion_EstadoCFDI !== null ? item.Anulacion_EstadoCFDI : '',
                                    anulacion_EstadoCFDIServicio: item.Anulacion_EstadoCFDIServicio !== null ? item.Anulacion_EstadoCFDIServicio : '',
                                    anulacion_SubEstadoCFDIServicio: item.Anulacion_SubEstadoCFDIServicio !== null ? item.Anulacion_SubEstadoCFDIServicio : '',
                                    anulacion_HorasSolicitudCFDI: item.Anulacion_HorasSolicitudCFDI !== null ? item.Anulacion_HorasSolicitudCFDI : '',
                                    impuesto: item.Impuesto,
                                    total: item.Total,
                                    showModal: true, disabled: false,
                                    IEPS: item.IEPS,
                                    Descuento: item.Descuento,
                                    TipoFactura: item.TipoFactura,
                                    TipoComprobante: item.TipoComprobante,
                                    regimenFiscalCancelacion: item.RegimenFiscalCancelacion !== null ? item.RegimenFiscalCancelacion : ''
                                });
                            });
                            if (this.state.TipoFactura == "Global") {
                                this.SAT_MotivoCancelacion_ListaFiltro_TipoFactura(4)
                                this.setState({ disabledTipoFacturaCancelacion: true, regimenFiscalCancelacion: "04" });
                            } else {
                                this.SAT_MotivoCancelacion_ListaFiltro_TipoFactura(0)
                                this.setState({ disabledTipoFacturaCancelacion: false });
                            }
                            this.setState({ articulos: Data });
                        } else {
                            alert("No existe la factura fiscal o ya fue anulada, verifique.");
                            this.onClean();
                        }
                    }
                })
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });
        }
    }

    verificar_Factura() {
        const { anulacion_EstadoCFDI } = this.state;
        switch (anulacion_EstadoCFDI) {
            case "APLICADO":
                alert("La factura fiscal ya fue anulada, verifique.");
                return false;
            case "PENDIENTE":
                return true;
            case "RECHAZADO":
                alert("La factura no puede ser anulada porque el receptor rechazó la anulación.");
                return false;
            case "EN PROCESO":
                return true;
            default:
                alert("Consulte una factura");
                return false;
        }
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.verificar_Factura())
            this.anular();
    }

    anular() {
        const { Suc_Id, factura, regimenFiscalCancelacion, uuidRel } = this.state;
        const { isSiteInterno } = this.props;
        if (regimenFiscalCancelacion != '') {
            if (isSiteInterno == '1') {
                if (confirm("¿Desea anular la factura fiscal Nº " + this.state.factura + "?")) {
                    this.setState({ anulacionDisabled: true });
                    Factura_Anulacion({ pSucursal: Suc_Id, pFactura: factura, pRegimenFiscalCancelacion: regimenFiscalCancelacion, pUUID: uuidRel })
                        .then(({ data: Response }) => {
                            this.setState({ anulacionDisabled: false });
                            const { Message, Data } = Response;
                            if (Message !== '') {
                                alert(Message);
                            } else {
                                const { Exitoso, Mensaje_Error, Codigo_Error, Anulacion_EstadoCFDI, Anulacion_SubEstadoCFDIServicio,
                                    Anulacion_EstadoCFDIServicio, Anulacion_HorasSolicitudCFDI } = Data;
                                //alert("Exitoso:" + Exitoso);
                                if (!Exitoso) {
                                    alert("Error: " + Mensaje_Error + ". Código:" + Codigo_Error);
                                } else {
                                    switch (Anulacion_EstadoCFDI) {
                                        case "EN PROCESO":
                                            alert("La factura sigue en Proceso de Anulación. Estado CFDI:" + Anulacion_EstadoCFDI + " Estado SAT:" + Anulacion_EstadoCFDIServicio + " SubEstado SAT:" + Anulacion_SubEstadoCFDIServicio + " Horas solicitud de anulación:" + Anulacion_HorasSolicitudCFDI);
                                            break;
                                        case "APLICADO":
                                            alert("La Factura ha sido Anulada. Estado CFDI: " + Anulacion_EstadoCFDI);
                                            break;
                                        default:
                                            alert("Estado CFDI: " + Anulacion_EstadoCFDI)
                                            break;
                                    }
                                    this.onClean();
                                }
                            }
                        })
                        .catch((err) => { console.log(err); this.setState({ anulacionDisabled: false }); });
                }
            }
        } else {
            alert("Error: Debe Seleccionar un Motivo de Cancelación.");
        }
    }

    render() {
        const { baseUrl, Suc_Id, factura, rfc, uuid, uuidRel, fiscalTipo, anulacion_EstadoCFDI, anulacion_EstadoCFDIServicio, anulacion_SubEstadoCFDIServicio,
            anulacion_HorasSolicitudCFDI, impuesto, total, articulos, sucursales, showModal, disabled, anulacionDisabled, regimenFiscalCancelaciones, regimenFiscalCancelacion, Serie, FiltroBusqueda, TipoComprobante, TipoFactura, IEPS, Descuento, disabledTipoFacturaCancelacion } = this.state;
        const linkStyle = { 'pointerEvents': disabled ? 'none' : 'auto' };
        const cssClassSpin = disabled ? 'fas fa-spinner fa-spin' : 'fas fa-search';
        const cssClassSpinAnular = anulacionDisabled ? 'fas fa-spinner fa-spin' : 'fas fa-save';
        const linkStyleDivTable = { 'overflowY': 'auto', 'width': '100%', 'height': '200px' };
        
        return (
            <Fragment>
                <div className="row" id="consulta">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12">
                                <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right" style={linkStyle}>
                                    <i className="fas fa-angle-double-left"></i>
                                </Link>
                            </div>
                        </div>

                        <form onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="form-group col-md-3">
                                            <label>Filtro Búsqueda:</label>
                                            <input type="text" className="form-control" name="FiltroBusqueda" value={FiltroBusqueda} placeholder=""
                                                onChange={this.onChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>Serie:</label>
                                            <input type="text" className="form-control" name="Serie" value={Serie} placeholder=""
                                                onChange={this.onChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>Sucursal:</label>
                                            <select className="form-control" value={Suc_Id} name="Suc_Id" onChange={this.onChange}>
                                                {
                                                    sucursales.map((item, index) =>
                                                        <option key={index} value={item.Suc_Id}>{item.Nombre}</option>
                                                    )
                                                }
                                            </select>
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>Número Factura:</label>
                                            <input type="text" className="form-control" name="factura" value={factura} placeholder="########" readOnly={disabled}
                                                onChange={this.onChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <button type="button" className="btn btn-custom-theme margin-top-30 ml-sm-3" disabled={disabled}
                                                onClick={this.onConsultarFactura}>
                                                <i className={cssClassSpin}></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label>RFC:</label>
                                            <input type="text" className="form-control" name="RFC" value={rfc} placeholder="###" readOnly={disabled}
                                                onChange={this.onChange} />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>UUID:</label>
                                            <input type="text" className="form-control" name="UUID" value={uuid} placeholder="###" readOnly={disabled}
                                                onChange={this.onChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label>Estado CFDI SAT:</label>
                                            <input type="text" className="form-control" name="anulacion_EstadoCFDIServicio" value={anulacion_EstadoCFDIServicio} placeholder="###" readOnly={disabled}
                                                onChange={this.onChange} />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>SubEstado CFDI SAT:</label>
                                            <input type="text" className="form-control" name="anulacion_SubEstadoCFDIServicio" value={anulacion_SubEstadoCFDIServicio} placeholder="###" readOnly={disabled}
                                                onChange={this.onChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label>Estado CFDI:</label>
                                            <input type="text" className="form-control" name="anulacion_EstadoCFDI" value={anulacion_EstadoCFDI} placeholder="###" readOnly={disabled}/>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Horas Solicitud Anulación:</label>
                                            <input type="text" className="form-control" name="anulacion_HorasSolicitudCFDI" value={anulacion_HorasSolicitudCFDI} placeholder="###" readOnly={disabled}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label>Tipo Comprobante:</label>
                                            <input type="text" className="form-control" name="TipoComprobante" value={TipoComprobante} placeholder="###" readOnly={disabled}
                                                 />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Tipo Factura:</label>
                                            <input type="text" className="form-control" name="TipoFactura" value={TipoFactura} placeholder="###" readOnly={disabled}
                                                />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label>Descuento:</label>
                                            <input type="text" className="form-control" name="Descuento" value={Descuento} placeholder="###" readOnly={disabled}
                                                />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>IEPS:</label>
                                            <input type="text" className="form-control" name="IEPS" value={IEPS} placeholder="###" readOnly={disabled}
                                                 />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="Impuesto">IVA:</label>
                                            <input id="Impuesto" type="text" className="form-control" name="Impuesto" value={impuesto} placeholder="###" readOnly={disabled}
                                                 />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Total:</label>
                                            <input type="text" className="form-control" name="Total" value={total} placeholder="###" readOnly={disabled}
                                                onChange={this.onChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label>Motivo Cancelación:</label>
                                                <select className="form-control" value={regimenFiscalCancelacion} name="regimenFiscalCancelacion" onChange={this.onChange}>
                                                    {
                                                        regimenFiscalCancelaciones.map((item, index) =>
                                                            <option key={index} value={item.Clave}>{item.Clave} - {item.Descripcion}</option>
                                                        )
                                                    }
                                                </select>
                                        </div>
                                    </div>


                                    <div className="row" hidden={this.state.stateUuidRelacionado}>
                                        <div className="form-group col-md-12">
                                            <label>UUID:</label>
                                            <input type="text" className="form-control" name="UUIDRel" value={uuidRel} placeholder="###" readOnly={disabled}
                                                onChange={this.onChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-12 form-group ">
                                            <button type="button" className="btn btn-custom-theme float-right" onClick={this.onClean}>
                                                <i className="fas fa-undo-alt"></i>
                                            </button>
                                            <button type="sumbit" className="btn btn-custom-theme float-right mr-sm-1" disabled={anulacionDisabled}>
                                                <i className={cssClassSpinAnular}></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-1"></div>
                                    <div className="col-md-10">
                                        <div style={linkStyleDivTable}>
                                            <table className="table table-striped table-hover">
                                                <thead><tr><th>Caja</th><th>Fecha</th><th>Ticket</th><th>Código</th><th>Articulo</th><th>Total Linea</th></tr></thead>
                                                <tbody>
                                                    {
                                                        articulos.map((item, key) => {
                                                            return (
                                                                <tr key={key}>
                                                                    <td>{item.Caja_Id}</td><td>{item.Fecha}</td><td>{item.Factura_Id}</td>
                                                                    <td>{item.Articulo_Id}</td><td>{item.Articulo_Nombre}</td><td>{item.Detalle_Total}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
};


// WEBPACK FOOTER //
// ./Public/src/js/component/anulacion/index.jsx